import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import NProgress from 'nprogress' // Progress 进度条
import 'nprogress/nprogress.css' // Progress 进度条样式

import {
	getToken,
	checkAuth
} from '@/util/auth' // 验权

import Layout from '@/pages/layout/layout';

const _import = require('./_import')
const whiteList = ['/login'] // 不重定向白名单


Vue.use(Router)

const router = new Router({
	scrollBehavior: () => ({
		y: 0
	}),
	routes: [
		{
			path: '/login',
			name: 'login',
			component: _import('login/login')
		},
		{
			path: '/',
			name: 'home',
			component: Layout,
			redirect: '/home',
			children: [{
				path: '/home',
				name: 'homeIndex',
				component: _import('home/index')
			}]
		}, {
			path: '/project',
			name: 'project',
			component: Layout,
			redirect: '/project',
			children: [{
				path: '/project',
				name: 'projectIndex',
				component: _import('project/index')
			}
			]
		},{
			path: '/user',
			name: 'user',
			component: Layout,
			redirect: '/user',
			children: [{
				path: '/user',
				name: 'userIndex',
				component: _import('user/index')
			}
			]
		},
		{
			path: '/area',
			name: 'area',
			component: Layout,
			redirect: '/area',
			children: [{
				path: '/area',
				name: 'areaIndex',
				component: _import('area/index')
			}
			]
		}, {
			path: '/add-normal',
			name: 'add-normal',
			component: _import('add-normal/index')
		}, {
			path: '/add-sence',
			name: 'add-sence',
			component: _import('add-sence/index')
		}, {
			path: '/add-ir',
			name: 'add-ir',
			component: _import('add-ir/index')
		}
	]
})

router.beforeEach((to, from, next) => {
	NProgress.start() // 开启Progress
	if (checkAuth()) { // 判断token是否有效
		next();
		if (to.path === '/login') {
			next({
				path: '/'
			})
		} else {
			// if (store.getters.menus.length === 0) {
			//   //获取权限菜单
			//   store.dispatch('GetUserMenu').then(res => {
			// 	// let menu = store.getters.menus;
			// 	// store.dispatch('GenerateRoutes', {
			// 	//   menu
			// 	// }).then(() => {
			// 	//   router.addRoutes(store.getters.addRouters)
			// 	//   next({ ...to
			// 	//   })
			// 	// })
			// 	next();
			//   })
			// } else {
			next()
			// }
		}
	} else {
		if (whiteList.indexOf(to.path) !== -1) { // 在免登录白名单，直接进入
			next()
		} else {
			next({
				path: '/login',
				query: {
					redirect: to.fullPath
				}
			})
			NProgress.done() // 在hash模式下 改变手动改变hash 重定向回来 不会触发afterEach 暂时hack方案 ps：history模式下无问题，可删除该行！
		}
	}
})

router.afterEach(() => {
	NProgress.done() // 结束Progress
})

export default router;



// WEBPACK FOOTER //
// ./src/router/index.js